import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { GET_CUSTOMER_REQUESTS_KEY } from '~/features/customers/hooks/useGetCustomerRequests'
import { useNotifyError } from '~/features/hooks/useNotifyError'
import { supabaseApi } from '~/supabase/api'

export const useDeleteCustomerRequests = () => {
  const queryClient = useQueryClient()

  const { mutate: notifyError } = useNotifyError()

  return useMutation({
    mutationKey: ['delete-customer-requests'] as const,
    mutationFn: async (ids: number[]) => {
      await Promise.all(
        ids.map(async (id) => {
          const { error } = await supabaseApi.from('customer_requests').delete().eq('id', id)

          if (error) {
            toast.error('Customer request could not be deleted')
            notifyError({
              data: { id },
              error,
              message: 'Customer request could not be deleted',
              function: 'useDeleteCustomerRequests',
            })

            throw error
          }
        })
      )
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_CUSTOMER_REQUESTS_KEY] })
      toast.success('Customer request successfully deleted')
    },
  })
}
